import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Controller,
  ControllerWrapper,
  FieldWrapper,
  FormFieldsContainer,
  Label,
  RegularField,
  useFormContext,
  useResponsive,
} from '@common-fe/common-fe';

import { AddProviderForm, AddProviderFormField } from "@/modules/UseMyMoney/widgets/FieldSetup/hooks/useAddProviderForm";

const AddProviderModalForm = () => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const {
    control,
    formState: { errors },
  } = useFormContext<AddProviderForm>();
  
  return (
    <Box
      pad={isMobile ? 'spacing16' : { vertical: 'spacing24', horizontal: 'spacing32' }}
      background="canvas"
      round="container1Round"
    >
      <FormFieldsContainer>
        <FieldWrapper>
          <Label
            name={AddProviderFormField.providerName}
            isNarrow
            showRequireIcon
          >
            {t('Provider/ Merchant name')}
          </Label>

          <ControllerWrapper errorText={errors?.[AddProviderFormField.providerName]?.message}>
            <Controller
              name={AddProviderFormField.providerName}
              control={control}
              render={({ field }) => (
                <RegularField
                  testId="add-provider-from_provider-name"
                  name={AddProviderFormField.providerName}
                  value={field.value}
                  onChange={field.onChange}
                  editMode
                  placeholder={t('Enter name')}
                  isError={!!errors?.[AddProviderFormField.providerName]?.message}
                />
              )}
              />
          </ControllerWrapper>
        </FieldWrapper>
      </FormFieldsContainer>
    </Box>
  );
};

export default AddProviderModalForm;
